import './index.scss';
import reportWebVitals from './reportWebVitals';
import { Application } from 'stimulus'
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start();
// @ts-ignore
const context = require.context("./controllers", true, /\.js$/);
application.load(definitionsFromContext(context))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
